import api from "actions/api.js"


export function getJobs(personid) {
    return api(`profile/${personid}/jobs`)
}

export function postJob(job) {
    const { personid, employer, position, fromdate, todate } = job

    return api("personjob",
        {
            method: "POST",
            body: JSON.stringify({
                personid, employer, position, fromdate, todate
            })
        })
}

export function putJob(job) {
    const { id, personid, employer, position, fromdate, todate } = job

    return api(`personjob/${id}`,
        {
            method: "PUT",
            body: JSON.stringify({
                personid, employer, position, fromdate, todate
            })
        })
}

export function deleteJob(id) {
    return api(`personjob/${id}`,
        {
            method: "DELETE"
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/jobs/api.js
 **/